import * as React from "react";
import { useMemo } from "react";
import { all, CountryProperty } from "country-codes-list";

import { Select } from "affinityUI/form/inputs/select";

import { SelectField } from "../select";

export const SelectCountryField: React.FC<React.ComponentProps<typeof Select>> = ({ children, ...props }) => {
  const options: Array<{ value: string; label: string }> = useMemo(() => {
    return [
      {
        value: "",
        label: "Select a country",
      },
    ].concat(
      all().map((country) => ({
        value: country["countryCode" as CountryProperty],
        label: country["countryNameEn" as CountryProperty],
      }))
    );
  }, []);
  const { name } = props;
  return (
    <SelectField name={name} options={options}>
      {children}
    </SelectField>
  );
};
